// Calendar dates as YYYY-MM-DD in the viewer's zone. `new Date('2026-08-03')` would be UTC midnight
// and can land on the previous local day, so parsing goes through the numeric constructor.
export const toCalendarDate = (date: Date) => {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};

export const fromCalendarDate = (iso: string) => {
  const [year, month, day] = iso.split('-').map(Number);
  return new Date(year, month - 1, day);
};
